import { render } from "./ShowNote.vue?vue&type=template&id=96f5cdb6&scoped=true"
import script from "./ShowNote.vue?vue&type=script&lang=js"
export * from "./ShowNote.vue?vue&type=script&lang=js"

import "./ShowNote.vue?vue&type=style&index=0&id=96f5cdb6&lang=scss&scoped=true"

import exportComponent from "/home/esesja/domains/app.esesja.mda.pl/public_html/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-96f5cdb6"]])

export default __exports__